module.exports = __webpack_public_path__ + "02_very_short_yellow.c3956bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_very_short_yellow.png
// module id = P38f
// module chunks = 0